import React from 'react';
import { Col, Row } from '@gjensidige/core-grid';
import { Text } from '@gjensidige/core-typography';
import { useCmsContext } from '@gjensidige/service-cms';

import tracker from '../tracking';
import { AppStep, ScenarioStep } from '../types/enums';
import { useCheckListContext } from '../context/CheckListProvider';
import { CriticalButton } from './Button';
import styles from './Start.module.scss';

const Start = () => {
  const { getText } = useCmsContext();
  const { setAppStep } = useCheckListContext();

  const goToChecklist = () => {
    setAppStep(AppStep.CHECKLIST);
    tracker.onScenarioStepChange(ScenarioStep.FAUCET);
  };

  return (
    <Row flexClass="justify-content-center">
      <Col md={6} className={styles.textCenter}>
        <Text size="lead">{getText('housing.check.landing.text')}</Text>
        <CriticalButton onClick={goToChecklist} className={styles.button}>
          {getText('housing.check.landing.button')}
        </CriticalButton>
      </Col>
    </Row>
  );
};

export default Start;
